import React from "react";
import { PDialogStyle as S } from "./PDialog.style";
import { Dialog, DialogProps } from "primereact/dialog";
import { useClassNames } from "hooks/useClassNames";

export type PDialogProps = Omit<DialogProps, "visible"> & { visible?: boolean };

export const PDialog = React.forwardRef<Dialog, PDialogProps>((props, ref) => {
  const className = useClassNames(
    {
      "no-header-dialog": props.showHeader === false,
    },
    props.className,
  );
  return (
    <S.PDialog
      blockScroll={true}
      visible={props.visible === false ? false : true}
      focusOnShow={false}
      {...props}
      className={className}
      ref={ref}
    />
  );
});
